import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { IndicatorStep } from './IndicatorStep';
import { useGetInstructionsQuery } from 'src/services/ai-instruction/aiInstructionApi';

export const AiInstructionsTrigger = ({
  aiInstructionId,
}: {
  aiInstructionId: string;
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const { data: publishedInstructions = [] } = useGetInstructionsQuery();

  const instruction = useMemo(
    () =>
      publishedInstructions.find(
        published => published.ai_instruction_id === aiInstructionId,
      ),
    [aiInstructionId, publishedInstructions],
  );

  return (
    <IndicatorStep
      message={t('aiInstructionsTrigger.message', {
        name:
          instruction?.name || t('aiInstructionsTrigger.deletedInstruction'),
      })}
    />
  );
};
